<template>
  <div
    class="w-10 relative transition-all duration-300 ease-smooth group-hover:scale-110 group-hover:text-accent-100"
    :class="{ 'scale-110 text-accent-100': active, 'text-theme-100': !active }">
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42 47"
      class="w-full">
      <g filter="url(#a)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 6a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3h-5.424a3 3 0 0 0-2.039.799L21 38l-4.537-4.201A3 3 0 0 0 14.424 33H9a3 3 0 0 1-3-3V6Z"
          fill="currentColor" />
        <path
          d="M9 3.5h24A2.5 2.5 0 0 1 35.5 6v24a2.5 2.5 0 0 1-2.5 2.5h-5.424a3.5 3.5 0 0 0-2.378.932L21 37.319l-4.198-3.887a3.5 3.5 0 0 0-2.378-.932H9A2.5 2.5 0 0 1 6.5 30V6A2.5 2.5 0 0 1 9 3.5Z"
          stroke="#fff" />
      </g>
      <defs>
        <filter
          id="a"
          x="0"
          y="0"
          width="42"
          height="47"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix values="0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0.5 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_203_115" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_203_115" result="shape" />
        </filter>
      </defs>
    </svg>
    <Typography
      as="span"
      variant="caption"
      class="absolute left-1/2 top-2 -translate-x-1/2 text-white font-bold flex items-center justify-center">
      {{ count }}
    </Typography>
  </div>
</template>

<script setup lang="ts">
import { Typography } from '@gro-up/ui/primitives'

defineProps<{
  count: number
  active: boolean
}>()
</script>
